import classNames from 'classnames'
import { ReactNode } from 'react'

export const Note = (props: { children: ReactNode; className?: string }) => {
  return (
    <p className={classNames('text-brandGrayForLightBg text-xs', props.className)}>
      {props.children}
    </p>
  )
}
